export default "__VITE_ASSET__CYqYyiGw__"